export enum EBodyPart
{
    LeftLeg,
    RightLeg,
    BothLegs,
    LeftArm,
    RightArm,
    BothArms
}
